export default {"src":"/_next/static/media/noun-working-capital.27e063a2.svg","height":59,"width":51};